import React, { useState } from 'react';
import styled from 'styled-components';
import { usePartner } from 'packages/smart-home-support/partner';
import { renderTemplate } from 'packages/smart-home-support/utils';
import { Faq } from '../models';

const faqFontColor: string = '#1B1B1B';

const ExpandableItem = styled.div`
  color: ${faqFontColor};
  padding: 35px 15px;
  width: 100%;
  box-sizing: border-box;
  border-top: 1px solid ${faqFontColor};
  &:last-child {
    border-bottom: 1px solid ${faqFontColor};
  }
`;

const ExpandableItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  &:hover {
    cursor: pointer;
  }
`;

const ExpandableItemTitle = styled.span<{ expanded: boolean }>`
  padding-right: 20px;

  font-style: normal;
  font-size: 18px;

  ${(props) => (props.expanded ? `color: ${props.theme.colors.faqAccent}; font-weight: bold` : '')}
`;

const ExpansionIcon = styled.span`
  height: 12px;
  width: 12px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.colors.primaryAccent};
`;

const FaqAnswer = styled.div`
  padding-top: 35px;

  font-style: normal;
  font-weight: normal;
  line-height: 22px;
  font-size: 18px;
`;

const FaqItem: React.FunctionComponent<{ selectedFaqTopic: number; expandedByDefault?: boolean } & Faq> = (props) => {
  const [{ claimUrl, helpNumber }] = usePartner();
  const [expanded, setExpanded] = useState(Boolean(props.expandedByDefault));
  const templateVars = {
    claimUrl: claimUrl || '',
    helpNumber,
  };

  return (
    <>
      {props.topicId === props.selectedFaqTopic && (
        <ExpandableItem>
          <ExpandableItemHeader onClick={() => setExpanded(!expanded)}>
            <ExpandableItemTitle expanded={expanded}>{props.text}</ExpandableItemTitle>
            <ExpansionIcon>{expanded ? '-' : '+'}</ExpansionIcon>
          </ExpandableItemHeader>
          {expanded && <FaqAnswer dangerouslySetInnerHTML={{ __html: renderTemplate(props.answer, templateVars) }} />}
        </ExpandableItem>
      )}
    </>
  );
};

export default FaqItem;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/faqpage/components/FaqItem.tsx